(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(
        this.name + ":winningsTextContainer"
      );

      this._totalWinText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsText"
      );

      this.show(false);

      this._textAnimTimeline = undefined;
      this._animOut = undefined;
    };

    onOrientationChange() {
      const layoutProp = layoutController.getCurrentLayoutProperties();
      let xOffSet = layoutProp.landscape ? 44 : 0;
      const xPos = layoutProp.width / 2 + xOffSet;
      const yPos = layoutProp.height / 2;
      this.position = { x: xPos, y: yPos };
    }

    setText = function (value) {
      var valueText = gdk.formatCurrency(value);
      this._totalWinText.setText(valueText);

      const layoutProp = layoutController.getCurrentLayoutProperties();
      let xOffSet = layoutProp.landscape ? 44 : 0;
      const xPos = layoutProp.width / 2 + xOffSet;
      const yPos = layoutProp.height / 2;
      this.position = { x: xPos, y: yPos };
    };

    animate = function (introOnly, cyclingWins) {
      const layoutProp = layoutController.getCurrentLayoutProperties();
      let xOffSet = layoutProp.landscape ? 44 : 0;
      const xPos = layoutProp.width / 2 + xOffSet;
      const yPos = layoutProp.height / 2;
      this.position = { x: xPos, y: yPos };
      let finalScale = 1;

      if (cyclingWins) {
        finalScale = 0.6;
      } else {
        gameController.toggleReelDark(true);
      }

      this.scale.x = finalScale / 2;
      this.scale.y = finalScale / 2;
      this.alpha = 0;

      this._textAnimTimeline = gsap
        .timeline()
        .to(this, {
          duration: 0.2,
          alpha: 1,
        })
        .to(
          this.scale,
          {
            duration: 0.6,
            ease: "back.out(2)",
            x: finalScale,
            y: finalScale,
            onStart: () => {
              if (!gameController.muteCyclingWins) {
                // soundManager.play("winAmountIn");
              }
            },
            onUpdate: () => {
              const layoutProp = layoutController.getCurrentLayoutProperties();
              let xOffSet = layoutProp.landscape ? 44 : 0;
              const xPos = layoutProp.width / 2 + xOffSet;
              const yPos = layoutProp.height / 2;
              this.position = { x: xPos, y: yPos };
            },
            onComplete: () => {
              this.scale.set(finalScale);
              if (!introOnly) {
                this.animateOut();
              }
            },
          },
          "<"
        );
    };

    animateOut = function () {
      const layoutProp = layoutController.getCurrentLayoutProperties();
      let xOffSet = layoutProp.landscape ? 44 : 0;
      const xPos = layoutProp.width / 2 + xOffSet;
      const yPos = layoutProp.height / 2;
      this.position = { x: xPos, y: yPos };

      gameController.toggleReelDark(false, 0.3, 0.2);

      const scaleTo = this.scale.x / 2;

      this._animOut = gsap
        .timeline()
        .to(this.scale, {
          duration: 0.6,
          ease: "back.in(3)",
          x: scaleTo,
          y: scaleTo,
          onStart: () => {
            if (!gameController.muteCyclingWins) {
              // soundManager.play("winAmountOut");
            }
          },
          onComplete: () => {},
        })
        .to(
          this,
          {
            duration: 0.2,
            alpha: 0,
          },
          "<+0.4"
        );

      gsap.to(this.position, {
        duration: 0.6,
        ease: "back.in(3)",
        y:
          layoutController.getCurrentLayoutProperties().height -
          layoutController.getCurrentLayoutProperties().height / 6,
      });
    };

    cycleAnimate = function () {
      gsap.fromTo(
        this.scale,
        {
          x: 0,
          y: 0,
        },
        {
          duration: 1,
          ease: "back.out(2)",
          x: 2,
          y: 2,
        }
      );
    };

    skip = function () {
      this._textAnimTimeline?.progress(1);
    };

    show = function (show, value) {
      this._container.visible = show;

      if (value) this.setText(value);
    };

    setWinText = function (showWinText) {
      if (showWinText) {
        this._totalWinText.visible = false;
      } else {
        this._totalWinText.visible = true;
      }
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    "winningsText",
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
